module.exports = __webpack_public_path__ + "img/01.e6caa14d.png";